import './App.css';
import { RESTClientImpl } from './features/services/RESTClient';
import { RestClientUT } from './features/services/RESTClientUT';
import { CHCLayout } from './features/ui/CHCLayout';

function App() {
  return (<CHCLayout client={
    process.env.NODE_ENV==='development'? RestClientUT.CreateInstance('http://localhost') :
    RESTClientImpl.CreateInstance(process.env.REACT_APP_REST_API_URI!)}/>);
}

export default App;
